require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-new-partnership-with-seattle-central-college-increases-access-to-education.json") })
        }
      }, "path---blog-new-partnership-with-seattle-central-college-increases-access-to-education");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-new-partnership-with-seattle-central-college-increases-access-to-education!./.cache/json/blog-new-partnership-with-seattle-central-college-increases-access-to-education.json
// module id = 976
// module chunks = 231608221292675